import { useState } from 'react'
import dynamic from 'next/dynamic'
import Info from '@/assets/common/info.inline.svg'
import Text from '@/stories/components/Common/NewText'

const Modal = dynamic(() => import('@/stories/components/Common/Modal'), {
  ssr: false,
})

const H2heading = ({
  bottomsheetInfo,
  display_name = '',
  as_on = '',
  containerClass = '',
}: {
  bottomsheetInfo?: string
  display_name?: string | undefined
  as_on?: string | undefined
  containerClass?: string
}) => {
  const [showModal, setShowModal] = useState<boolean>(false)

  return (
    <div className="mb-6 flex items-baseline justify-between border-b-[0.5px] pb-2.5 lg:pb-6">
      <div className="flex flex-col gap-1">
        {display_name && (
          <Text appearance="heading2" tag="h2" addClassName={containerClass}>
            {display_name}
          </Text>
        )}
        {as_on && (
          <Text appearance="caption" addClassName="text-brand-grey-base">
            {as_on}
          </Text>
        )}
      </div>
      {bottomsheetInfo && (
        <button
          type="button"
          aria-label="Show additional information"
          className="h-4 min-h-4 w-4 min-w-4 cursor-pointer"
          onClick={() => setShowModal(true)}
        >
          <Info />
        </button>
      )}
      {showModal && bottomsheetInfo && (
        <Modal
          onClose={() => setShowModal(false)}
          showModal={showModal}
          bodyClassName="max-w-lg"
        >
          <div className="max-h-96 overflow-y-scroll">
            <div
              dangerouslySetInnerHTML={{
                __html: bottomsheetInfo,
              }}
            />
          </div>
        </Modal>
      )}
    </div>
  )
}

export default H2heading
